module.exports = __webpack_public_path__ + "static/media/CheckMark.11b5973e.svg";